import React, { useState } from "react";
import {
  HomeIcon,
  Man,
  Map,
  Ruler,
  RulerYAxis,
  SquareFill,
  SquareFillBottomFront,
  SquareFillTop,
  SquareFillTopBack,
  ThreeDCube,
} from "../../Icons";
import ResizableBox from "../common/ResizeableBox";
import KeyMapDrawer from "./KeyMapDrawer";

export default function ToolBar({
  activeColor = "#fff",
  inactiveColor = "#000",
  onChange,
}) {
  const [activeTool, setActiveTool] = useState();
  const [isExpandMap, setIsExpandMap] = useState(false);
  const tools = [
    { title: "man", icon: Man },
    { title: "cube", icon: ThreeDCube },
    { title: "top", icon: SquareFillTop },
    { title: "topBack", icon: SquareFillTopBack },
    { title: "bottomFront", icon: SquareFillBottomFront },
    { title: "square", icon: SquareFill },
    { title: "map", icon: Map },
    { title: "ruler", icon: Ruler },
    { title: "ruler y axis", icon: RulerYAxis },
    { title: "home", icon: HomeIcon },
  ];

  const handleSelect = (tool) => {
    setActiveTool(tool.title);
    onChange && onChange(tool.title);
  };

  return (
    <div className="absolute top-0 left-0 w-full h-full  flex flex-col">
      <div className="p-4 md:p-[30px] !pt-12 xl:!pt-6">
        {" "}
        <div className="p-2 rounded-[10px] bg-[#E6E6E6] flex items-center justify-center flex-wrap gap-2 shadow-sm w-fit mx-auto">
          {tools.map((tool, index) => {
            const Icon = tool.icon;
            const isActive = activeTool === tool.title;

            return (
              <button
                key={index}
                onClick={() => {
                  handleSelect(tool);
                }}
                className={`p-2 rounded-md transition-all duration-200 aspect-square w-9 flex items-center justify-center ${
                  isActive ? "bg-[#E96F0C] " : "bg-white"
                }`}
              >
                <Icon
                  size={20}
                  color={isActive ? activeColor : inactiveColor}
                  className="transition-colors duration-200"
                />
              </button>
            );
          })}
        </div>
      </div>

      {/* Map */}
      <div className="relative flex-1   w-full ">
        {activeTool === "map" && (
          <div
            className={` bg-[#F0F0F0]   
                transition-all duration-500 ease-in-out shadow-lg absolute z-[6]
                ${
                  isExpandMap
                    ? "w-full right-0 bottom-0"
                    : "w-[553px] max-w-[calc(100%-24px)] md:right-5 md:bottom-5 right-3 bottom-3"
                } 
                
               `}
          >
            <ResizableBox
              direction="vertical"
              initialSize={425}
              minSize={10}
              maxSize={600}
              resize_handle_position="top"
              isShowHandler={isExpandMap}
            >
              <KeyMapDrawer
                setIsExpandMap={setIsExpandMap}
                isExpandMap={isExpandMap}
                setActiveTool={setActiveTool}
              />
            </ResizableBox>
          </div>
        )}
      </div>
    </div>
  );
}
